<template>
    <el-container class="historie">
        <div class="historie-wrapper" id="historie-content">
            <el-carousel :height="'500'" indicator-position="outside" :autoplay="false" class="historie-carousel">
                <el-carousel-item v-for="item in texts" :key="item" >
                    <div class="item__content historie-content" > 
                        <h3>{{ item.headline }}</h3>
                        <span style="text-align: justify">{{ item.text }}</span>
                    </div>
                </el-carousel-item>
            </el-carousel>

        </div>
    </el-container>
</template>

<script>

import { onMounted} from '@vue/runtime-core';

export default {
    name: "ONas",
    setup(){
        const texts = [
            {
            "image": "",
            "headline": "Historie letiště",
            "text": "V dobývání kroměřížského vzdušného prostoru byli odvážní průkopníci hned dva. Antonín Šilhánek a jeho asistent Hugo Tichý. V roce 1910 se pustili do stavby „létadla“, jak se tehdy psalo. Šlo o jednoplošník s dvouválcovým rotačním motorem, který si Šilhánek sám zkonstruoval. Před závěrečným potažením plátnem byl konstruktér povolán do c. k. armády, čímž projekt skončil. Nikdy nebyl dokončen. V tomtéž roce se místní sportovní klub Haná pokusil pozvat k letecké atrakci ing. Jana Kašpara, slavného českého aviatika, což se ale nepodařilo. \n Kroměřížské letectví bylo od počátků a vlastně u toho zůstalo dodnes spjato s lokalitou Hráza, ležící jihovýchodně od centra města. Od roku 1900 zde bylo vojenské cvičiště z kterého ho se časem vyvinulo letiště. Na něm se také uskutečnil první start a to 2. července 1911. Asi patnáct tisíc diváků sledovalo třináct minut letícího ing- Jana Kašpara (v letounu Kašpar JK). Trvalo dalších šestatřicet let, než zde byla pilotovi odhalena pamětní deska; byla mimochodem vůbec první v Československu."
            }
            // {
            // "image": "",
            // "headline": "První republika",
            // "text": "Kroměřížské letectví bylo od počátků a vlastně u toho zůstalo dodnes spjato s lokalitou Hráza, ležící jihovýchodně od centra města. Od roku 1900 zde bylo vojenské cvičiště z kterého ho se časem vyvinulo letiště. Na něm se také uskutečnil první start a to 2. července 1911. Asi patnáct tisíc diváků sledovalo třináct minut letícího ing- Jana Kašpara (v letounu Kašpar JK). Trvalo dalších šestatřicet let, než zde byla pilotovi odhalena pamětní deska; byla mimochodem vůbec první v Československu."
            // },
            // {
            // "image": "",
            // "headline": "Válečné období",
            // "text": "Nabízíme vyhlídkové lety z letiště Kroměříž. Podívejte se na svět z jiné perspektivy!"
            // },
            // {
            // "image": "",
            // "headline": "Poválečné období",
            // "text": "Kroměřížské letectví bylo od počátků a vlastně u toho zůstalo dodnes spjato s lokalitou Hráza, ležící jihovýchodně od centra města. Od roku 1900 zde bylo vojenské cvičiště z kterého ho se časem vyvinulo letiště. Na něm se také uskutečnil první start a to 2. července 1911. Asi patnáct tisíc diváků sledovalo třináct minut letícího ing- Jana Kašpara (v letounu Kašpar JK). Trvalo dalších šestatřicet let, než zde byla pilotovi odhalena pamětní deska; byla mimochodem vůbec první v Československu."
            // },
            // {
            // "image": "",
            // "headline": "Současnost",
            // "text": "V dobývání kroměřížského vzdušného prostoru byli odvážní průkopníci hned dva. Antonín Šilhánek a jeho asistent Hugo Tichý. V roce 1910 se pustili do stavby „létadla“, jak se tehdy psalo. Šlo o jednoplošník s dvouválcovým rotačním motorem, který si Šilhánek sám zkonstruoval. Před závěrečným potažením plátnem byl konstruktér povolán do c. k. armády, čímž projekt skončil. Nikdy nebyl dokončen. V tomtéž roce se místní sportovní klub Haná pokusil pozvat k letecké atrakci ing. Jana Kašpara, slavného českého aviatika, což se ale nepodařilo. \n Kroměřížské letectví bylo od počátků a vlastně u toho zůstalo dodnes spjato s lokalitou Hráza, ležící jihovýchodně od centra města. Od roku 1900 zde bylo vojenské cvičiště z kterého ho se časem vyvinulo letiště. Na něm se také uskutečnil první start a to 2. července 1911. Asi patnáct tisíc diváků sledovalo třináct minut letícího ing- Jana Kašpara (v letounu Kašpar JK). Trvalo dalších šestatřicet let, než zde byla pilotovi odhalena pamětní deska; byla mimochodem vůbec první v Československu."
            // },
        ];

        function throttle(f, delay) {
            let timer = 0;
            return function(...args) {
                clearTimeout(timer);
                timer = setTimeout(() => f.apply(this, args), delay);
            }
        }

        onMounted(()=>{
            var carouselItems = document.getElementById("historie-content").getElementsByClassName("item__content");
            var carouselContainer = document.getElementById("historie-content").getElementsByClassName("el-carousel__container")

            const resizeObserver = new ResizeObserver(throttle((s)=>{
                let heights_list = Math.max.apply(Math, s.map(function(o) { return o.contentRect.height}))
                let stylestr = "height:"+ String(Math.ceil(heights_list)+30) +"px !important;"
                carouselContainer[0].setAttribute("style", stylestr)            
            }, 500));

            let i = 0;
            for(i; i < carouselItems.length; i++){
                // Dynamic add observe - vsechny itemy carouselu
                resizeObserver.observe(carouselItems[i]);
            }
            
        })
        return {texts}
    }
}
</script>

<style scoped>


.historie-wrapper{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.historie-item{
    margin: auto;
    width: 80%;
    /* height: 100%; */

}
.historie-carousel{
    width: 1550px;
    max-width: 90%;
    /* height: 200px; */
}

.historie {
  width: 100%;
  background-image: url("../../src/assets/cover/ingkaspar-cb.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size:cover;
}


.historie-content{
    background: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    max-width: 80%;
    /* max-height: 100%; */
    margin: auto;
    padding: 15px;

    color: rgb(255, 255, 255);
    
}
span{
    text-justify: inter-word;
}


</style>
